export default () => {

  const courseBooking = document.querySelector('.course__booking__bottom');
  const courseAcc = document.querySelector('.lecturer-container');

  if (!courseBooking || !courseAcc) {
    return;
  }

  const accordionButton = courseBooking.querySelector('.course__booking__hide-button');

  if (!accordionButton) {
    return;
  }

  const accordionButtons = document.querySelectorAll('.accordion-button');

  let windowHeight = 0;

  let isHidden = true;
  let unstickied = true

  let courseBookingHeight = 0;
  let courseAccBottomEdge = 0;

  const hide = () => {
    courseBooking.classList.add('course__booking--is-collapsed');
    accordionButton.classList.add('course__booking__hide-button--is-active');
  }

  const show = () => {
    courseBooking.classList.remove('course__booking--is-collapsed');
    accordionButton.classList.remove('course__booking__hide-button--is-active');
  }

  accordionButton.addEventListener('click', () => {
    isHidden ? show() : hide();
    isHidden = !isHidden;
  });

  const updateBookingValues = () => {
    const {height: height } = courseBooking.getBoundingClientRect();
    const { y: yAcc, top: topAcc, bottom: bottomAcc, height: heightAcc } = courseAcc.getBoundingClientRect();

    windowHeight = window.innerHeight;
    courseAccBottomEdge =  topAcc + heightAcc + window.scrollY;
    courseBookingHeight = height;
  };


  const checkStates = () => {

    if (window.scrollY > (courseAccBottomEdge - window.innerHeight + courseBookingHeight)) {
      accordionButton.classList.add('course__booking__hide-button--is-hidden');
      courseBooking.classList.remove('course__booking--is-collapsed');
      unstickied = true
    } else if (window.scrollY > 0) {
      accordionButton.classList.remove('course__booking__hide-button--is-hidden');
      courseBooking.classList.add('course__booking--is-collapsed');
      unstickied = false
      hide();
    }
  };


  window.addEventListener('resize', () => {
    updateBookingValues();
  });

  ['product-lecturer-slider-updated', 'course-page-calendar-loaded'].forEach(event => {
    document.addEventListener(event, () => {
      updateBookingValues();
      checkStates();
    });
  });


  [...accordionButtons].forEach(btn => {
    btn.addEventListener('click', function() {
      setTimeout(function() {
        updateBookingValues(true);
        checkStates();
      }, 500)
    });
  });

  window.addEventListener('scroll', () => {
    checkStates();
  });

  updateBookingValues();
  checkStates();
}
